module.exports = __webpack_public_path__ + "img/catering_menu_1.bf05259d.jpg";